/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSeparatorHorizontal = createReactComponent(
  "separator-horizontal",
  "IconSeparatorHorizontal",
  [
    ["path", { d: "M4 12l16 0", key: "svg-0" }],
    ["path", { d: "M8 8l4 -4l4 4", key: "svg-1" }],
    ["path", { d: "M16 16l-4 4l-4 -4", key: "svg-2" }]
  ]
);

export { IconSeparatorHorizontal as default };
//# sourceMappingURL=IconSeparatorHorizontal.js.map
